import classNames from 'classnames';
import { FC, MouseEvent, ReactElement, useMemo, useRef } from 'react';
import Spinner from '../Spinner/Spinner';
import { getButtonSpinnerColor, getButtonSpinnerSize, getButtonStyle } from './helpers';
import './style.scss';
import { ButtonAppearance, ButtonSize, IButtonProps } from './types';

const Button: FC<IButtonProps> = ({
  title = 'button',
  children = null,
  onClick,
  //
  disabled = false,
  loading = false,
  stretched = false,
  appearance = ButtonAppearance.PRIMARY,
  size = ButtonSize.MEDIUM,
  //
  spinnerColor: propsSpinnerColor,
  style,
  className,
  titleClassName,
  ...props
}: IButtonProps): ReactElement => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const spinnerSize = useMemo((): number => getButtonSpinnerSize(size), [size]);
  const spinnerColor = useMemo((): string => getButtonSpinnerColor({ appearance, spinnerColor: propsSpinnerColor }), [appearance, propsSpinnerColor]);

  const _onClick = (event: any) => {
    if (disabled || loading) {
      if (buttonRef && buttonRef.current?.contains(event.target)) {
        event.stopPropagation();
      }
    }
  };

  const onClickHandler = (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    if (disabled || loading) return;
    if (onClick) onClick(event);
  };

  const buttonClassName = useMemo((): string => {
    return getButtonStyle({ stretched, appearance, size, className, loading, disabled });
  }, [stretched, appearance, size, className, loading, disabled]);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <button {...props} ref={buttonRef} onClick={onClickHandler} disabled={disabled || loading} className={buttonClassName} style={style}>
      {loading && <Spinner size={spinnerSize} color={spinnerColor} className="button-spinner" />}
      {/* keeps button width the same when spinner is showing */}
      <div onClick={_onClick} className={classNames('button__children', titleClassName)} style={{ opacity: loading ? 0 : 1 }}>
        {children || title}
      </div>
    </button>
  );
};

export default Button;
